import {
  AppBar,
  Box,
  Tab,
  Tabs,
  useTheme,
} from "@mui/material"
import { useLocation, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import SwipeableViews from "react-swipeable-views"
import React from "react"

import { getData } from "../core/CreateEditOptions/getData"
import { TabPanel } from "./TabPanel"
import { BusinessDetailInfo } from "./BusinessDetailInfo"
import { a11yProps } from "./businesses-utils"
import { BusinessAdsComponent } from "../../BusinessAdsComponent"
import { BusinessOffersComponent } from "../../BusinessOfferComponent"
import { BusinessNotificationsComponent } from "../../BusinessNotificationsComponent"
/**
 * BusinessDetail component that displays detailed information about a business
 * Uses tabs to organize different aspects: details, ads, offers, and notifications
 */
export const BusinessDetail = () => {
  const { id } = useParams()
  const { state } = useLocation()
  const [data, setData] = useState()
  const [value, setValue] = useState(0)
  const theme = useTheme()

  /**
   * Handles tab change
   * @param event - Change event
   * @param newValue - New tab index
   */
  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue)
  }

  /**
   * Handles swipe change index
   * @param index - New index
   */
  const handleChangeIndex = (index: React.SetStateAction<number>) => {
    setValue(index)
  }

  /**
   * Reloads business data from Firebase
   */
  function reload() {
    getData({ path: `/businesses/${id}`, setData })
  }

  // Load data on component mount
  useEffect(() => {
    if (state?.id) {
      setData(state)
    } else {
      reload()
    }
  }, [id, state])

  return (
    <Box sx={{ bgcolor: "background.paper", width: "80vw" }}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Business Detail" {...a11yProps(0)} />
          <Tab label="Business Ads" {...a11yProps(1)} />
          <Tab label="Business Offers" {...a11yProps(2)} />
          <Tab label="Business Notifications" {...a11yProps(3)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <BusinessDetailInfo id={id!} data={data} reload={reload} />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <BusinessAdsComponent businessId={id} />
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <BusinessOffersComponent businessId={id} />
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          <BusinessNotificationsComponent businessId={id} />
        </TabPanel>
      </SwipeableViews>
    </Box>
  )
}